import refs from '../helpers/refs'

class CInputMultiSelect {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.a-input-multi-select')
    .forEach(el => new CInputMultiSelect(el))
})
